/* eslint camelcase: 0 */
const client = require("./app.json");

module.exports = {
    client,
};